module.exports = __webpack_public_path__ + "static/media/elaf1.36885d6a.jpeg";